/**
 * Functions to determine Google Tag Manager settings
 * Contains defaults, which are overridden via environment variables.
 *
 * Functions are used instead of constants to allow potential for runtime changes.
 */

const isProduction = () => ['production'].includes(process.env.NEXT_PUBLIC_APP_ENV || '');

const auth = {
  requiredForPublicPages: () => {
    if (process.env.AUTH_REQUIRED_FOR_PUBLIC_PAGES) {
      return process.env.AUTH_REQUIRED_FOR_PUBLIC_PAGES.toLowerCase() === 'true';
    }

    // default to false in Prod, true in Dev
    if (isProduction()) {
      return false;
    } else {
      return true;
    }
  },
};

export default auth;

export const SUBS_SCHEMA = '_SUBS';
export const TRIAL_SCHEMA = '_TRAL';
export const CONTENT_AI_ONLY_SCHEMAS = ['_HIMS', '_REVI'];
